import { createNativeStackNavigator, NativeStackScreenProps } from "@react-navigation/native-stack";
import OverviewScreen from "./OverviewScreen";
import TermsScreen from "./TermsScreen";
import AccountDetailsScreen from "./AccountDetailsScreen";
import SuccessScreen from "./SuccessScreen";
import { headerScreenOptions } from "../../components/HeaderBackButton";
import { Platform } from "react-native";
import { gql, useQuery } from "@apollo/client";
import { CURRENT_MEMBER_FRAGMENT, CurrentMember } from "../fragments";
import { FormProvider, useForm } from "react-hook-form";
import { defaultValues } from "./formData";

export const QUERY = gql`
  query enrollQuery {
    currentMember {
      ...CurrentMemberFragment
    }
  }
  ${CURRENT_MEMBER_FRAGMENT}
`;

interface Query {
  currentMember: CurrentMember;
}

type EnrollStackParamList = { Overview: undefined; Terms: undefined; AccountDetails: undefined; Success: undefined };

const Stack = createNativeStackNavigator<EnrollStackParamList>();
export type ScreenProps<
  name extends keyof EnrollStackParamList,
  NavigatorID extends string | undefined = undefined,
> = NativeStackScreenProps<EnrollStackParamList, name, NavigatorID>;
export default function EnrollScreen() {
  const { data } = useQuery<Query>(QUERY);
  const enrolled = data?.currentMember.enrolled;

  const methods = useForm({ mode: "onTouched", defaultValues });

  return (
    <FormProvider {...methods}>
      <Stack.Navigator>
        <Stack.Group screenOptions={headerScreenOptions}>
          {enrolled ? (
            <Stack.Screen name="Success" component={SuccessScreen} options={{ title: "Enroll Success", headerShown: false }} />
          ) : (
            <>
              <Stack.Screen
                name="Overview"
                component={OverviewScreen}
                options={{ title: "Enroll", headerShown: Platform.OS !== "web" }}
              />
              <Stack.Screen
                name="Terms"
                component={TermsScreen}
                options={{ title: "Terms & Conditions", headerShown: Platform.OS !== "web" }}
              />
              <Stack.Screen
                name="AccountDetails"
                component={AccountDetailsScreen}
                options={{ title: "Account Details", headerShown: Platform.OS !== "web" }}
              />
            </>
          )}
        </Stack.Group>
      </Stack.Navigator>
    </FormProvider>
  );
}
